import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useDeleteConfirmDialogStyles = makeStyles({
  errorText: {
    fontSize: fontScale.caption,
    lineHeight: tokens.lineHeightBase200,
    color: tokens.colorPaletteRedForeground1,
    margin: '0',
    marginTop: tokens.spacingVerticalXS,
  },
});
